import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import ErrorList from 'Components/UI/ErrorList';


const Layout = () => {
  const { onSubmit, errors } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
          <MetaControlField attr={'primaryText'} />
          <MetaControlField attr={'phoneNumber'} fullWidth />
          <ErrorList title={'Errors occurred while submitting'} errors={errors} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Send Code'}
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: submit phone number');
            onSubmit();
          }}
          test={'security-settings-button-sms-register-modal-send-code'}
        />
      </FDDialogActions>
    </>
  );
};

export default Layout;
